<template>
  <div class="card bg-secondary mb-3" v-if="!$wait.is('load.faixa.preco')">
    <div class="card-body">
      <h5 class="mb-3">Resumo do Pedido - {{orderFormatoString}}</h5>
      <table class="table table-sm table-borderless">
        <thead v-if="Object.keys(sacolaTitulosAgrupada).length">
          <tr>
            <th scope="col" class="borderbottom">Título</th>
            <th scope="col" class="borderbottom text-right">Discos</th>
          </tr>
        </thead>
        <tbody v-if="Object.keys(sacolaTitulosAgrupada).length">
          <tr v-for="(titulo,nome) in sacolaTitulosAgrupada" :key="titulo.titulo_id">
            <td class="titulo-resume-text">{{nome}}</td>
            <td class="text-right"><small v-html="cartCheckDisks(titulo)"></small></td>
          </tr>
          <tr>
            <td scope="col" class="borderline"><strong>Total de Discos:</strong></td>
            <td scope="col" class="borderline text-right"><strong>{{orderTotalDisks}}</strong></td>
          </tr>
        </tbody>
        <thead v-if="Object.keys(sacolaTitulosAgrupadaGold).length">
          <tr>
            <th scope="col" class="borderbottom">Dublagens Douradas</th>
            <th scope="col" class="borderbottom text-right">Valor</th>
          </tr>
        </thead>
        <tbody v-if="Object.keys(sacolaTitulosAgrupadaGold).length">
          <tr v-for="(titulo,nome) in sacolaTitulosAgrupadaGold" :key="titulo.titulo_id">
            <td class="titulo-resume-text">{{nome}}</td>
            <td class="text-right"><small v-html="returnCurrency(titulo[0].preco)"></small></td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td scope="col"><strong>Subtotal:</strong></td>
            <td scope="col" class="text-right"><strong>{{returnCurrency(orderSubTotal)}}</strong></td>
          </tr>
          <tr v-if="orderTaxes > 0">
            <td scope="col"><strong>Taxa Boleto:</strong></td>
            <td scope="col" class="text-right"><strong>{{isFloat(orderTaxes) ? returnCurrency(orderTaxes) : orderTaxes}}</strong></td>
          </tr>
          <tr v-if="orderShipping !== null">
            <td scope="col"><strong>Frete:</strong></td>
            <td scope="col" class="text-right"><strong>{{isFloat(orderShipping) ? returnCurrency(orderShipping) : orderShipping}}</strong></td>
          </tr>
          <tr>
            <td scope="col"><strong>Total:</strong></td>
            <td scope="col" class="text-right"><strong>{{returnCurrency(orderTotal)}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

//import checkDisks from '@/store/cart';

export default {
  name: 'orderDetail',
  data() {
    return {}
  },
  methods: {
    returnCurrency(value){
      value = parseFloat(value);
      return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    checkDisks(media) {
      return ( media.discos !== null && !media.preco ) ? media.discos : ( !media.preco ) ? 1 : 0;
    },
    cartCheckDisks(item){
      return item.reduce((acc, media) => acc + this.checkDisks(media), 0);
    },
    isFloat(n) {
      return n === +n && n !== (n|0);
    },
    ...mapActions('cart', [
      'loadFaixaPreco',
    ]),
  },
  computed: {
    ...mapGetters('cart', [
      'sacolaTitulosAgrupada',
      'sacolaTitulosAgrupadaGold',
      'orderTotalDisks',
      'getPriceRange',
      'orderShipping',
      'orderSubTotal',
      'orderTaxes',
      'orderTotal'
    ]),
    orderFormatoString(){
      return (this.$parent.radio.formato == 'digital') ? 'Mídia Digital' : 'Mídia Física';
    },
  },
  created() {
    this.$wait.start('load.faixa.preco');
    this.loadFaixaPreco();
    this.$wait.end('load.faixa.preco');
  }
};
</script>
<style lang="scss" scoped>
  $gray: #525f7f;
  .borderline {
    border-top: 1px solid rgba($gray,0.3) !important;
  }

  .borderbottom {
    border-bottom: 1px solid rgba($gray,0.3) !important;
  }

  .titulo-resume-text {
    font-size: 0.9em;
  }
</style>
